@if (this.visible()) {
<section class="status-banner" [class.outage]="this.severity() === 'error'" [attr.aria-labelledby]="this.provider() + '-status-title'" [attr.data-testid]="this.provider() + '-status'">
  <div role="status" aria-live="polite">
    <p-message [severity]="this.severity()" class="w-100" [style]="{ background: 'transparent', border: 'none', padding: '.5rem', boxShadow: 'none' }">
      <div class="status-heading">
        <i class="status-icon" [class]="this.severity() === 'error' ? 'ri-error-warning-fill' : 'ri-alert-fill'" aria-hidden="true"></i>
        <div>
          <strong class="status-title" [id]="this.provider() + '-status-title'">{{ this.title() }}</strong>
          @if (this.unknown()) {
            @if (this.provider() === 'falai') {
              <p class="mb-0" i18n="@@falai-status-unavailable-help">Der aktuelle Status konnte nicht geprüft werden. Öffne die fal.ai-Statusseite oder warte auf die nächste automatische Prüfung.</p>
            } @else if (this.provider() === 'elevenlabs') {
              <p class="mb-0" i18n="@@elevenlabs-status-unavailable-help">Der aktuelle Status konnte nicht geprüft werden. Öffne die ElevenLabs-Statusseite oder warte auf die nächste automatische Prüfung.</p>
            } @else if (this.provider() === 'did') {
              <p class="mb-0" i18n="@@did-status-unavailable-help">Der aktuelle Status konnte nicht geprüft werden. Öffne die D-ID-Statusseite oder warte auf die nächste automatische Prüfung.</p>
            } @else if (this.avatarProvider()) {
              <p class="mb-0" i18n="@@avatar-provider-status-unavailable-help">Der aktuelle Status konnte nicht geprüft werden. Öffne die HeyGen-Statusseite oder warte auf die nächste automatische Prüfung.</p>
            } @else {
            <p class="mb-0" i18n="@@openai-status-unavailable-help">Der aktuelle Status konnte nicht geprüft werden. Öffne die OpenAI-Statusseite oder warte auf die nächste automatische Prüfung.</p>
            }
          } @else {
            @if (this.provider() === 'falai') {
              <p class="mb-0" i18n="@@falai-status-disruption-help">fal.ai meldet ein Problem. Die Bildgenerierung und Bildbearbeitung können betroffen sein. Prüfe die Meldung auf der fal.ai-Statusseite. Deine Bots bleiben nutzbar.</p>
            } @else if (this.provider() === 'elevenlabs') {
              <p class="mb-0" i18n="@@elevenlabs-status-disruption-help">ElevenLabs meldet ein Problem. Die Sprachausgabe kann betroffen sein. Prüfe die Meldung auf der ElevenLabs-Statusseite. Deine Bots bleiben nutzbar.</p>
            } @else if (this.provider() === 'did') {
              <p class="mb-0" i18n="@@did-status-disruption-help">D-ID meldet ein Problem. Echtzeit-Avatare können betroffen sein. Prüfe die Meldung auf der D-ID-Statusseite. Deine Bots bleiben nutzbar.</p>
            } @else if (this.avatarProvider()) {
              <p class="mb-0" i18n="@@avatar-provider-status-disruption-help">{{ this.providerName() }} meldet ein Problem. Avatare über diese API können betroffen sein. Prüfe die Meldung auf der HeyGen-Statusseite. Deine Bots bleiben nutzbar.</p>
            } @else {
            <p class="mb-0" i18n="@@openai-status-disruption-help">OpenAI-Funktionen können verzögert reagieren oder fehlschlagen. Prüfe die betroffenen Dienste in den Statusdetails. Deine Bots bleiben nutzbar.</p>
            }
          }
        </div>
      </div>
    </p-message>
  </div>
  <div class="status-line">
    <button
      pButton
      type="button"
      class="p-button-text p-button-sm p-button-secondary"
      [attr.aria-expanded]="this.expanded()"
      [attr.aria-controls]="this.detailsId()"
      (click)="this.expanded.set(!this.expanded())"
    ><span pButtonLabel i18n="@@openai-status-details">Statusdetails</span></button>
    <a [href]="this.statusPageUrl()" target="_blank" rel="noopener noreferrer" class="small" i18n="@@provider-status-source">{{ this.providerName() }}-Statusseite öffnen</a>
  </div>
  @if (this.expanded()) {
    <div [id]="this.detailsId()" class="status-details small">
      @if (this.provider() === 'falai') {
        <p i18n="@@falai-status-scope">Anbieterstatus für Model API und Official Models, keine Prüfung eines konkreten Modells. Kontingent- und API-Schlüsselprobleme werden hier nicht erkannt.</p>
      } @else if (this.provider() === 'elevenlabs') {
        <p i18n="@@elevenlabs-status-scope">Gesamtstatus von ElevenLabs, keine gesonderte Prüfung der Sprachausgabe. Auch andere ElevenLabs-Dienste können die Meldung auslösen. Kontingent- und API-Schlüsselprobleme werden hier nicht erkannt.</p>
      } @else if (this.provider() === 'did') {
        <p i18n="@@did-status-scope">Anbieterstatus der D-ID Agents API für Echtzeit und Streaming. Die Meldungen gelten nicht zwingend für jeden Bot. Kontingent- und API-Schlüsselprobleme werden hier nicht erkannt.</p>
      } @else if (this.avatarProvider()) {
        <p i18n="@@avatar-provider-status-scope">Anbieterstatus der {{ this.providerName() }}-API, keine gesonderte Prüfung einzelner Streaming-Funktionen. Die Meldungen gelten nicht zwingend für jeden Bot. Kontingent- und API-Schlüsselprobleme werden hier nicht erkannt.</p>
      } @else {
      <p i18n="@@openai-status-scope">Anbieterstatus für die API-Dienste der Engine, nicht für ChatGPT. Die Meldungen gelten nicht zwingend für jeden Bot. Kontingent- und API-Schlüsselprobleme werden hier nicht erkannt.</p>
      }
      @if (this.status(); as status) {
        <p>
          <span i18n="@@openai-status-checked">Letzte Prüfung:</span> {{ this.formatTime(status.checkedAt) }}
        </p>
        @if (this.unknown() && status.lastSuccessfulAt) {
          <p i18n="@@openai-status-stale">Veraltete Daten – letzte erfolgreiche Prüfung: {{ this.formatTime(status.lastSuccessfulAt) }}. Die folgenden Dienstmeldungen sind nicht aktuell.</p>
        }
        <ul class="mb-0">
          @for (component of status.components; track component.id) {
            <li><strong>{{ component.name }}:</strong> {{ this.componentState(component.status) }}</li>
          }
        </ul>
      }
    </div>
  }
</section>
}
